import React from 'react'
import { avatarColors } from '../../../mockups/Profile/profile_data'
import { GoHeartFill } from 'react-icons/go'
import { MdRemoveRedEye } from 'react-icons/md'

function ProjectContent() {
  return (
        <div className='my-12' >
        <div 
        style={{backgroundColor : avatarColors[4] }}
        className={`h-[230px] md:h-[350px] lg-[400px] w-full rounded-xl`}  />

        <div className='py-5'>
            <p className='text-xl font-semibold'>Solar Panels - Westshire Manor</p>
            <p className='text-sm my-4'>By: Westshire Manor</p>

            <p className='font-semibold'>Stage: Building</p>
            <p className='my-5'>Project Description: Encourage participation in community service and volunteer programs
             to promote a sense of unity and address social issues. This will not only help address specific 
             problems within the community. </p>

             <div className='flex my-5 space-x-12'>
                 <button>
                    <GoHeartFill className='text-red-600 inline text-2xl mr-1' />45
                </button>
                <button>
                    <MdRemoveRedEye className='text-blue-600 inline text-2xl mr-1' />12
                </button>
             </div>
        </div>

      </div>
  )
}

export default ProjectContent
